if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"pflm_host","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return 9121 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}